module.exports = __webpack_public_path__ + "static/img/app02.ed1cf68.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app02.png
// module id = ih8f
// module chunks = 1